<template>
  <div class="editAndSave">
    <myHeader :headerData="headerData" v-on:toSaveAddress="saveAddress"></myHeader>
    <div class="manageRow">
      <mt-cell title="收货人">
        <span class="required"><span class="hidden">收货人</span>*</span>
        <mt-field placeholder="请输入收货人" v-model="resData.receiverName"></mt-field>
        <i class="mint-cell-allow-right margin-left-20"></i>
      </mt-cell>
    </div>
    <div class="manageRow">
      <mt-cell title="手机号码">
        <span class="required"><span class="hidden">手机号码</span>*</span>
        <mt-field placeholder="请输入手机号码" type="number" v-model="resData.receiverTel"></mt-field>
        <i class="mint-cell-allow-right margin-left-20"></i>
      </mt-cell>
    </div>
    <div class="manageRow" @click="openAction(1)">
      <mt-cell title="省份">
        <span class="required"><span class="hidden">省份</span>*</span>
        <mt-field placeholder="请选择省份" readonly v-model="resData.provinceName"></mt-field>
        <i class="mint-cell-allow-right margin-left-20"></i>
      </mt-cell>
    </div>
    <div class="manageRow" @click="openAction(2)">
      <mt-cell title="城市">
        <span class="required"><span class="hidden">城市</span>*</span>
        <mt-field placeholder="请选择城市" readonly v-model="resData.cityName"></mt-field>
        <i class="mint-cell-allow-right margin-left-20"></i>
      </mt-cell>
    </div>
    <div class="manageRow" @click="openAction(3)">
      <mt-cell title="区县">
        <span class="required"><span class="hidden">区县</span>*</span>
        <mt-field placeholder="请选择区县" readonly v-model="resData.countyName"></mt-field>
        <i class="mint-cell-allow-right margin-left-20"></i>
      </mt-cell>
    </div>
    <div class="manageRow">
      <mt-cell title="收货人地址">
        <span class="required"><span class="hidden">收货人地址</span>*</span>
        <mt-field placeholder="请输入收货人地址" v-model="resData.roadDetail"></mt-field>
        <i class="mint-cell-allow-right margin-left-20"></i>
      </mt-cell>
    </div>   
    <div class="manageRow checkRow">
      <label class="mint-checklist-label" @click.prevent="changeDefault">
        <span class="mint-checkbox">
          <input type="checkbox" class="mint-checkbox-input" :checked="resData.isDefault">
          <span class="mint-checkbox-core"></span>
        </span> <span class="mint-checkbox-label">默认收货地址</span>
      </label>
      <div class="clear"></div>
    </div>
    <mt-actionsheet
      :actions="provinceAction"
      v-model="provinceVisible">
    </mt-actionsheet>
    <mt-actionsheet
      :actions="cityAction"
      v-model="cityVisible">
    </mt-actionsheet>
    <mt-actionsheet
      :actions="countyAction"
      v-model="countyVisible">
    </mt-actionsheet>

  </div>
</template>

<script>
  import myHeader from '../../components/header.vue';
  export default {
    name: 'editAndSave',
    components: {
      myHeader
    },
    created: function () {
      let addressItem = this.$route.query.addressItem;
      if (addressItem && addressItem.addressId) {
        this.resData = addressItem;
      } else {
        this.resData.isDefault = false;
      }
      this.getAddress(1);
    },
    methods: {
      saveAddress(){
        var _this = this;
        var data=_this.resData;
        if(!_this.$reg.txt.test(data.receiverName)){
          _this.$toast('收货人格式不正确');
          return false;
        }
        if(!_this.$reg.phone.test(data.receiverTel)){
          _this.$toast('手机号格式不正确');
          return false;
        }
        data.roadDetail=data.roadDetail.replace(/(^\s*)|(\s*$)/g, "");        
        if(_this.$reg.special.test(data.roadDetail)){
          _this.$toast('收货地址不能包含特殊字符');
          return false;
        }
        if (!data.provinceId) {
          _this.$toast("请选择省份");
          return false;
        }
        if (!data.cityId) {
          _this.$toast("请选择城市");
          return false;
        }
        if (!data.countyId) {
          _this.$toast("请选择区/县");
          return false;
        }
        if (!data.roadDetail) {
          _this.$toast("请填写收货人地址");
          return false;
        }
        _this.$http.post(_this.$api.SaveAddress, data, function (res) {
          if (res.success) {
            _this.$toast('保存成功!');
            _this.$router.go(-1);
          } else {
            _this.$toast(res.msg);
          }
        })
      },
      openAction(type){
        switch (type) {
          case 1:
            this.provinceVisible = true;
            break;
          case 2:
            if (!this.resData.provinceId) {
              this.$toast('请先选择省份');
              return
            }
            this.cityVisible = true;
            break;
          case 3:
            if (!this.resData.cityId || !this.resData.provinceId) {
              this.$toast('请先选择省份城市');
              return
            }
            this.countyVisible = true;
            break;
        }
      },
      getAddress(type){
        var url = '';
        var data = '';
        switch (type) {
          case 1:
            url = this.$api.QueryProvince;
            data = {
              platform: 1
            }
            break;
          case 2:
            url = this.$api.QueryCity;
            data = {
              platform: 1,
              parentId: this.resData.provinceId
            }
            break;
          case 3:
            url = this.$api.QueryCounty;
            data = {
              platform: 1,
              parentId: this.resData.cityId
            }
            break;
        }
        let _this = this;
        this.$http.get(url, data, function (res) {
          _this.setMethod(type, res.content.areaList)
        })
      },
      setMethod(type, data){
        var _this = this;
        for (let i = 0; i < data.length; i++) {
          data[i].method = function (e) {
            switch (type) {
              case 1:
                _this.resData.provinceId = e.id;
                _this.resData.provinceName = e.name;
                _this.resData.cityId = '';
                _this.resData.cityName = '';
                _this.resData.countyId = '';
                _this.resData.countyName = '';
                break;
              case 2:
                _this.resData.cityId = e.id;
                _this.resData.cityName = e.name;
                _this.resData.countyId = '';
                _this.resData.countyName = '';
                break;
              case 3:
                _this.resData.countyId = e.id;
                _this.resData.countyName = e.name;
                break;
            }
            if (type == 1 || type == 2) {
              _this.getAddress(type + 1);
            }
          };
        }
        switch (type) {
          case 1:
            this.provinceAction = data;
            this.cityAction = [];
            this.countyAction = [];
            break;
          case 2:
            this.cityAction = data;
            this.countyAction = [];
            break;
          case 3:
            this.countyAction = data;
            break;
        }
      },
      changeDefault(){
        if (this.resData.isDefault) {
          this.resData.isDefault = false;
        } else {
          this.resData.isDefault = true;
        }
      }
    },
    data () {
      return {
        headerData: {
          name: '编辑',
          isOut: false,
          save: 'toSaveAddress',
        },
        resData: {
          "relatedId": "",
          "platform": 1,
          "receiverName": "",
          "receiverTel": "",
          "countryId": "",
          "countryName": "",
          "provinceId": "",
          "provinceName": "",
          "cityId": "",
          "cityName": "",
          "countyId": "",
          "countyName": "",
          "roadDetail": "",
          "isDefault": false
        },
        provinceAction: [],
        provinceVisible: false,
        cityAction: [],
        cityVisible: false,
        countyAction: [],
        countyVisible: false,
      }
    }
  }
</script>
<style scoped>
  .mint-checklist-title {
    margin: 0;
  }
  .mint-cell-value{
    padding-left:10px;
  }
  .checkRow {
    padding: 10px;
    background: #fff;
  }
  .required{
    display:inline-block;
    padding-left:12px;
    line-height:48px;
    font-size:16px;
    color:red;
    position:absolute;
    left:0;
    z-index:10;
    vertical-align: middle;
  }
  .hidden{
    visibility:hidden;
  }
  .margin-left-20{
    margin-left:20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gift/editAndSave.vue